import React from "react";
import Box from "../../molecules/Box";
import Paper from "../../molecules/Paper";
import { SectionTitle, SectionSubtitle } from "../../molecules/Typography";
import { useStyles } from "./SectionCard.styles";

export interface SectionCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  headerAction?: React.ReactNode;
}

const SectionCard = ({ title, subtitle, children, className, headerAction }: SectionCardProps) => {
  const classes = useStyles();
  return (
    <Paper elevation={0} className={`${classes.root}${className ? ` ${className}` : ""}`}>
      <Box className={classes.header}>
        <Box className={classes.headerLeft}>
          <SectionTitle>{title}</SectionTitle>
          {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
        </Box>
        {headerAction && <Box className={classes.headerAction}>{headerAction}</Box>}
      </Box>
      <Box className={classes.body}>{children}</Box>
    </Paper>
  );
};

export default SectionCard;
